export default __webpack_public_path__ + "images/AutumnInformationBackground.web.png";